// Copyright (c) Bentley Systems
import { Parameter } from "../../Action/parameter";
import { Style } from "../../DataModels/style";
import { EfFieldValidationTypeEnum } from "../../Helpers/enumerators";
import {
  getCssValueFromString,
  parseStringToEfFieldValidationTypeEnum,
} from "../../Helpers/helper-functions";
import { FieldType } from "./field-type";

export class Field {
  public label: string | undefined;
  public name: string | undefined;
  public fieldId: number | undefined;
  public hidden: boolean | undefined;
  public editable: boolean | undefined;
  public length: number | undefined;
  public type: FieldType | undefined;
  public matchCodeId: number | undefined;
  public selectedValue: any;
  public autoStartActionId: number | undefined;
  public height: string | undefined;
  public required: boolean = false;
  public validationType: EfFieldValidationTypeEnum = EfFieldValidationTypeEnum.Default;

  constructor(
    initializer: any,
    urlParameters: Parameter[],
    styles: Style[] = [],
    fieldValue?: any,
  ) {
    if (initializer.name) {
      this.name = initializer.name;
    }
    if (
      initializer.efFieldTexts !== undefined &&
      initializer.efFieldTexts.length > 0
    ) {
      this.label = initializer.efFieldTexts[0].shortText;
    } else {
      if (initializer.label !== undefined) {
        this.label = initializer.label;
      } else {
        this.label = this.name;
      }
    }
    if (initializer.fieldId) {
      this.fieldId = initializer.fieldId;
    }
    if (initializer.hidden !== undefined) {
      this.hidden = initializer.hidden;
    }
    if (initializer.editable !== undefined) {
      this.editable = initializer.editable;
    }
    if (initializer.length) {
      this.length = initializer.length;
    }
    if (initializer.autoStartActionId) {
      this.autoStartActionId = initializer.autoStartActionId;
    }
    if (initializer.required !== undefined) {
      this.required = initializer.required;
    }
    if (initializer.validationType !== undefined) {
      const enumValue = parseStringToEfFieldValidationTypeEnum(
        initializer.validationType,
      );
      if (enumValue) {
        this.validationType = initializer.validationType;
      }
    }
    if (initializer.controlFieldStyleId) {
      const style = styles.find(
        (s) => s.styleId === initializer.controlFieldStyleId,
      );
      if (style !== undefined && style.data !== undefined) {
        const height = getCssValueFromString(style.data, "height");
        if (height !== "") {
          this.height = height;
        }
      }
    }

    if (initializer.type !== undefined) {
      this.type = initializer.type;
      this.matchCodeId = initializer.matchCodeId;
    } else {
      if (initializer.dawPicker === true) {
        this.type = FieldType.colorPicker;
      } else {
        if (initializer.dataType === "System.Boolean") {
          this.type = FieldType.checkBox;
        } else if (initializer.matchCodeId !== null) {
          this.type = FieldType.dropDown;
          this.matchCodeId = initializer.matchCodeId;
        } else {
          this.type = FieldType.text;
        }
      }
    }
    if (fieldValue !== undefined) {
      if (this.type === FieldType.checkBox) {
        if (fieldValue === "True") {
          this.selectedValue = true;
        }
        if (fieldValue === "False") {
          this.selectedValue = false;
        }
      } else {
        this.selectedValue = fieldValue;
      }
    }
    if (
      initializer.defaultSourceType === "P" &&
      initializer.defaultOccurrence === "A" &&
      initializer.defaultValue !== ""
    ) {
      const urlParameter = urlParameters.find(
        (p) => p.name === initializer.defaultValue,
      );
      if (urlParameter !== undefined) {
        this.selectedValue = urlParameter.value;
      }
    }
  }
}
